import { useEffect } from "react";

import { Link, useOutletContext } from "react-router";
import { BuildingServiceType, ServiceTypeEnum } from "../types/Building";
import Layout from "../components/Layout";
import { trackMarketplacePageView } from "../utils/analytics";
import { Spinner } from "../components/Spinner";
import useLivlyUser from "../context/UserProvider";
import {
  MarketplaceCategory,
  MarketplaceContext
} from "@/context/MarketplaceLayout";

export default function MarketplacePage() {
  const { isLoading, categories } = useOutletContext<MarketplaceContext>();
  const { user } = useLivlyUser();

  const { displayName } =
    user.building?.serviceTypes?.find(
      (service: BuildingServiceType) =>
        service.serviceType === ServiceTypeEnum.MarketPlace
    ) || {};

  useEffect(() => {
    trackMarketplacePageView();
  }, []);

  return (
    <Layout title={displayName || "Building Offers"}>
      {isLoading ? (
        <div className="flex items-center justify-center flex-1 my-56">
          <Spinner color="livly" size="xl" />
        </div>
      ) : (
        <>
          {user.status === "Applicant" && (
            <h2 className="mb-4">
              prepare your new apartment before you move in.
            </h2>
          )}
          <div className="mt-4">
            {(categories ?? []).length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {categories?.map((category) => (
                  <CategoryItem key={category.externalId} category={category} />
                ))}
              </div>
            ) : (
              <div className="flex items-center justify-center flex-1 my-56">
                There are no building offers available
              </div>
            )}
          </div>
        </>
      )}
    </Layout>
  );
}

function CategoryItem({ category }: { category: MarketplaceCategory }) {
  return (
    <Link to={`category/${category.externalId}`} className="mb-4 block">
      <div className="relative cursor-pointer transition-transform hover:scale-105">
        <img
          src={category.imageUrl}
          alt={category.title}
          className="object-cover w-full h-48 rounded-lg"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent rounded-lg flex items-end">
          <p className="text-white font-medium text-lg p-3">{category.title}</p>
        </div>
      </div>
    </Link>
  );
}
